import PropTypes from 'prop-types';
import * as React from 'react';

import { Head } from '../Head';
import Breadcrumbs from './Breadcrumbs';
import { MainLayout } from './MainLayout';
import { Link, useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'react-feather';

export const ContentLayout = ({ routes, children, title, end }) => {
  const navigate = useNavigate();
  return (
    <MainLayout>
      <Head title={title} />
      <div className="max-w-8xl mx-auto px-24 flex items-center justify-between mb-2">
        <Link
          onClick={() => navigate(-1)}
          className="bg-[#1E555C] w-12 h-12 rounded-full flex items-center justify-center"
        >
          <ChevronLeft className="text-white" />
        </Link>
      </div>
      {title && (
        <div className="max-w-8xl mx-auto px-24 flex items-center justify-between">
          <h1 className="text-xl font-semibold text-gray-100">{title}</h1>
          <div>{end}</div>
        </div>
      )}
      <div className="max-w-8xl mx-auto px-24">{children}</div>
    </MainLayout>
  );
};

ContentLayout.propTypes = {
  children: PropTypes.node.isRequired,
  // title: PropTypes.string.isRequired,
  end: PropTypes.node,
};
